import { getRetinaSrcs } from '@helpers/image';
import { youTubeIdParser } from '@helpers/utils';
import SvgPlay from '@img/icons/youtube-filled.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import ReactPlayer from 'react-player/youtube';
import S from './MediaEmbed.styles';
const MediaEmbed = (props) => {
    const [playing, setPlaying] = React.useState(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const videoRef = React.useRef(null);
    if (!props.image && !props.youtubeUrl) {
        return null;
    }
    const srcs = props.image ? getRetinaSrcs(props.image, 1020, 1020 / 573) : [];
    const videoId = props.youtubeUrl && !props.image ? youTubeIdParser(props.youtubeUrl) : '';
    return (React.createElement(S.Container, { id: props.anchorId, spacing: "none", "data-layout": "default" },
        React.createElement(S.MediaWrapper, null,
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.AspectRatio, { ...(props.youtubeUrl && !playing
                        ? { as: 'button', onClick: () => setPlaying(true) }
                        : {}) }, playing && props.youtubeUrl ? (React.createElement(S.Img, { as: "span" },
                    React.createElement(ReactPlayer, { url: props.youtubeUrl, playing: true, controls: true, width: "100%", height: "100%", ref: videoRef }))) : (React.createElement(React.Fragment, null,
                    props.image && (React.createElement(S.Img, { src: srcs[0], srcSet: srcs.join(','), alt: props.image.altText ?? props.caption, loading: 'lazy' })),
                    props.youtubeUrl && (React.createElement(React.Fragment, null,
                        videoId !== '' && (React.createElement(S.Img, { src: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`, role: "presentation", loading: 'lazy' })),
                        React.createElement(S.PlayIcon, null,
                            React.createElement(SvgPlay, null)))))))),
            props.caption && React.createElement(S.Caption, null, props.caption))));
};
export default MediaEmbed;
